/* eslint-disable angular/component-name */
angular.module('zc.zenclerkS')
  .component('noDataOverlay', {
    bindings: {
      customMessage: '@',
    },
    template: `
      <div class="no-data-overlay-wrapper">
        <span class="gray-box">
          {{$ctrl.message}}
        </span>
      </div>
    `,
    controller: noDataOverlayController,
  });


noDataOverlayController.$inject = ['$translate'];
function noDataOverlayController($translate) {
  const vm = this;

  vm.$onInit = () => {
    vm.message = $translate.instant('sites.dashboard.noDataOverlay.hyouji_surutame_ni');
    if(vm.customMessage) {
      vm.message = vm.customMessage;
    }
  };
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/sites/dashboard/no-data-overlay.component.js